import { render, staticRenderFns } from "./SidebarArtCategories.vue?vue&type=template&id=25d2bfc6&"
import script from "./SidebarArtCategories.vue?vue&type=script&lang=js&"
export * from "./SidebarArtCategories.vue?vue&type=script&lang=js&"
import style0 from "./SidebarArtCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VLayout})
